import React from 'react'
import { VoucherContextType } from '../../../../../../context/VoucherEntryContext';
import { useFormik } from 'formik';
import DialogBox from '../../../../../../constants/DialogBox';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../../../constants/InputTextBox';
import NepaliInputBox from '../../../../../../constants/NepaliInputBox';
import { handleNepaliInputChange, handleSelectBox } from '../../../../../../helpers/handleChange';
import SelectInputBox from '../../../../../../constants/SelectInputBox';
import { DebitCreditOptions, YesNoOptions } from '../../../../../../constants/Options';
import { EndBaseLine } from '../../../../../../constants/AppSpace';
import { Button } from '../../../../../../constants/Button';
import { postDataToTheServer } from '../../../../../../helpers/api';
import AppURL from '../../../../../../constants/AppURL';
import { ToastSuccess } from '../../../../../../constants/Toast';

interface ParticularCreateProps {
    openParticu: boolean;
    context: VoucherContextType;
    setOnParticu: React.Dispatch<React.SetStateAction<boolean>>;
    refetch?: () => void;
    particular_id?: number;
    particular_sn?:number;
}

const ParticularCreateView: React.FC<ParticularCreateProps> = ({ openParticu, particular_sn, particular_id, context, setOnParticu, refetch }) => {
    const { values: glid_value } = context;
    const initialValues = {
        particular_id: particular_id?.toString() ||"",
        particular_name: "",
        particular_name_nep: "",
        glid: glid_value?.glid || "",
        is_debit: "",
        status: "",
        particu_for_assets: "",
        assets_dep_pers: "",
        sub_gl_related_id: glid_value.sglsn ||"",
        virtual_pid: particular_sn?.toString()||"",
        branch_id: "",
    };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        // validationSchema: authorValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("glid", values.glid);
            formData.append("particular_name", values.particular_name);
            formData.append("particular_name_nep", values.particular_name_nep);
            formData.append("glid", values.glid);
            formData.append("virtual_pid", values.virtual_pid);
            formData.append("sub_gl_related_id", values.sub_gl_related_id);
            formData.append("status", values.status === "1" ? "1" : "0");
            formData.append("is_debit", values.is_debit === "1" ? "1" : "0");
            formData.append("branch_id", "1");
            try {
                await postDataToTheServer(AppURL.AccountURL + "account/particular/create/list/view/", formData).then((res) => {
                    if (res?.status === 201) {
                        ToastSuccess({ message: res?.message });
                        action.resetForm();
                        refetch?.();
                    }
                    action.resetForm();
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    return (
        <DialogBox headerName='Sub Ledger Add' open={openParticu} close={() => setOnParticu(false)}>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={1}>
                    <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
                        <InputTextBox
                            type='number'
                            label='GLID'
                            name='glid'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            disabled={true}
                            value={values.glid}
                            placeholder='10'
                            required={false}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
                        <InputTextBox
                            type='number'
                            label='SGLSN'
                            name='sglsn'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            disabled={true}
                            value={values.sub_gl_related_id}
                            placeholder='10'
                            required={false}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
                        <InputTextBox
                            type='number'
                            label='Particular ID'
                            name='particular_id'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            disabled={true}
                            value={values.particular_id}
                            placeholder='10'
                            required={false}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
                        <InputTextBox
                            type='number'
                            label='Particular SN'
                            name='virtual_pid'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            disabled={true}
                            value={values.virtual_pid}
                            placeholder='10'
                            required={false}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
                        <InputTextBox
                            type='text'
                            label='Particular Name'
                            name='particular_name'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            disabled={false}
                            error={errors.particular_name}
                            touched={touched.particular_name}
                            value={values.particular_name}
                            placeholder='Enter Particular Name'
                            required={true}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
                        <NepaliInputBox
                            label="Particular Name(Nepali)"
                            name='particular_name_nep'
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'particular_name_nep' })}
                            value={values.particular_name_nep}
                            error={errors.particular_name_nep}
                            handleBlur={handleBlur}
                            touched={touched.particular_name_nep}
                            placeholder='Enter Particular Name(Nepali)'
                            required={true} />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label="Debit/Credit"
                            options={DebitCreditOptions}
                            name='is_debit'
                            required={true}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            placeholder='Select Debit/Credit'
                            value={values.is_debit}
                            touched={touched.is_debit}
                        />
                    </Grid>
                  
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label="Status"
                            options={YesNoOptions}
                            name='status'
                            required={true}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            placeholder='Select status'
                            value={values.status}
                            touched={touched.status}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={20}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>
        </DialogBox>
    )
}

export default ParticularCreateView